import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelement, Component, ɵɵelementStart, ɵɵelementEnd, ɵɵadvance, ɵɵproperty, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵdirectiveInject, ɵɵnamespaceSVG, ɵɵnamespaceHTML, ɵɵtemplate, ɵɵsanitizeUrl, ɵɵtext, ɵɵtextInterpolate1, ɵɵtextInterpolate, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { RouterOutlet, RouterLinkWithHref, RouterModule } from '@angular/router';
import { EnvironmentService } from 'service-common';
import { TranslateDirective, TranslateModule } from '@ngx-translate/core';
import { NgIf, CommonModule } from '@angular/common';
import { ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';

class CdineshStaticPagesService {
    constructor() { }
    get Applogo() {
        return this._Applogo;
    }
    set Applogo(v) {
        this._Applogo = v;
    }
    get AppTitle() {
        return this._AppTitle;
    }
    set AppTitle(v) {
        this._AppTitle = v;
    }
}
CdineshStaticPagesService.ɵfac = function CdineshStaticPagesService_Factory(t) { return new (t || CdineshStaticPagesService)(); };
CdineshStaticPagesService.ɵprov = ɵɵdefineInjectable({ token: CdineshStaticPagesService, factory: CdineshStaticPagesService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CdineshStaticPagesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class CdineshStaticPagesComponent {
    constructor() { }
    ngOnInit() {
    }
}
CdineshStaticPagesComponent.ɵfac = function CdineshStaticPagesComponent_Factory(t) { return new (t || CdineshStaticPagesComponent)(); };
CdineshStaticPagesComponent.ɵcmp = ɵɵdefineComponent({ type: CdineshStaticPagesComponent, selectors: [["lib-cdinesh-static-pages"]], decls: 1, vars: 0, template: function CdineshStaticPagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "router-outlet");
    } }, directives: [RouterOutlet], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CdineshStaticPagesComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cdinesh-static-pages',
                template: `<router-outlet></router-outlet>`,
                styles: []
            }]
    }], function () { return []; }, null); })();

function HeaderComponent_li_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", 17);
    ɵɵelement(1, "a", 23);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("translate", "home.nav.login");
} }
function HeaderComponent_li_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", 17);
    ɵɵelement(1, "a", 24);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("translate", "home.nav.inventory");
} }
function HeaderComponent_li_27_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 17);
    ɵɵelementStart(1, "a", 25);
    ɵɵlistener("click", function HeaderComponent_li_27_Template_a_click_1_listener() { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.signOut(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("translate", "home.nav.signOut");
} }
class HeaderComponent {
    constructor(environment) {
        this.environment = environment;
        this.signIn = false;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
    }
    ngOnInit() {
        this.signIn = this.environment.IsGuestLogin || this.environment.IsLogin;
    }
    signOut() {
        this.environment.logout();
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵɵdirectiveInject(EnvironmentService)); };
HeaderComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderComponent, selectors: [["lib-header"]], decls: 28, vars: 8, consts: [[1, "wrapper", "getintouchpage"], [1, "sticky"], [1, "container"], [1, "navbar", "navbar-expand-lg", "py-4", "py-lg-4"], ["href", "/home", 1, "navbar-brand"], ["alt", "", "width", "65px", 3, "src"], ["type", "button", "data-toggle", "collapse", "data-target", "#navbarSupportedContent", "aria-controls", "navbarSupportedContent", "aria-expanded", "false", "aria-label", "Toggle navigation", 1, "navbar-toggler"], [1, ""], ["xmlns", "http://www.w3.org/2000/svg", "x", "0px", "y", "0px", "width", "50", "height", "40", "viewBox", "0 0 172 172", 2, "fill", "#000000"], ["transform", ""], ["fill", "none", "fill-rule", "nonzero", "stroke", "none", "stroke-width", "1", "stroke-linecap", "butt", "stroke-linejoin", "miter", "stroke-miterlimit", "10", "stroke-dasharray", "", "stroke-dashoffset", "0", "font-family", "none", "font-weight", "none", "font-size", "none", "text-anchor", "none", 2, "mix-blend-mode", "normal"], ["d", "M0,172v-172h172v172z", "fill", "none"], ["d", "", "fill", "none"], ["fill", "#ffffff"], ["d", "M21.5,37.625v10.75h129v-10.75zM21.5,80.625v10.75h129v-10.75zM21.5,123.625v10.75h129v-10.75z"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "main-nav"], [1, "nav-item"], ["href", "/home#about", 1, "nav-link", 3, "translate"], ["href", "/home#heritage", 1, "nav-link", 3, "translate"], ["href", "/home#services", 1, "nav-link", 3, "translate"], ["href", "#contact", 1, "nav-link", 3, "translate"], ["class", "nav-item", 4, "ngIf"], ["href", "https://www.cdinesh.in/Account/Login", "type", "submit", 1, "nav-link", "header-login-btn", 3, "translate"], ["routerLink", "/inventory", 1, "nav-link", 3, "translate"], [1, "nav-link", 3, "translate", "click"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "header", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "nav", 3);
        ɵɵelementStart(4, "a", 4);
        ɵɵelement(5, "img", 5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "button", 6);
        ɵɵelementStart(7, "span", 7);
        ɵɵnamespaceSVG();
        ɵɵelementStart(8, "svg", 8);
        ɵɵelementStart(9, "g", 9);
        ɵɵelementStart(10, "g", 10);
        ɵɵelement(11, "path", 11);
        ɵɵelement(12, "path", 12);
        ɵɵelementStart(13, "g", 13);
        ɵɵelement(14, "path", 14);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵnamespaceHTML();
        ɵɵelementStart(15, "div", 15);
        ɵɵelementStart(16, "ul", 16);
        ɵɵelementStart(17, "li", 17);
        ɵɵelement(18, "a", 18);
        ɵɵelementEnd();
        ɵɵelementStart(19, "li", 17);
        ɵɵelement(20, "a", 19);
        ɵɵelementEnd();
        ɵɵelementStart(21, "li", 17);
        ɵɵelement(22, "a", 20);
        ɵɵelementEnd();
        ɵɵelementStart(23, "li", 17);
        ɵɵelement(24, "a", 21);
        ɵɵelementEnd();
        ɵɵtemplate(25, HeaderComponent_li_25_Template, 2, 1, "li", 22);
        ɵɵtemplate(26, HeaderComponent_li_26_Template, 2, 1, "li", 22);
        ɵɵtemplate(27, HeaderComponent_li_27_Template, 2, 1, "li", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(13);
        ɵɵproperty("translate", "home.nav.about");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.nav.heritage");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.nav.services");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.nav.contact");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.signIn);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.signIn);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.signIn);
    } }, directives: [TranslateDirective, NgIf, RouterLinkWithHref], styles: ["header[_ngcontent-%COMP%]{background:0 0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-header',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }]; }, null); })();

class FooterComponent {
    constructor(environment) {
        this.environment = environment;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
    }
    ngOnInit() {
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(ɵɵdirectiveInject(EnvironmentService)); };
FooterComponent.ɵcmp = ɵɵdefineComponent({ type: FooterComponent, selectors: [["lib-footer"]], decls: 20, vars: 1, consts: [["id", "colophon", "role", "contentinfo", 1, "site-footer"], [1, "site-info", "container"], [1, "row"], ["role", "navigation", 1, "col-md-4", "text-center", "mb-3", "mb-md-0"], [1, "copyright", "col-md-8", "text-center"], [1, "ftrmenu"], ["href", "#"], ["routerLink", "/home/privacy"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "footer", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "nav", 3);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "ul", 5);
        ɵɵelementStart(7, "li");
        ɵɵelementStart(8, "a", 6);
        ɵɵtext(9, "Terms and Conditions");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "li");
        ɵɵtext(11, "|");
        ɵɵelementEnd();
        ɵɵelementStart(12, "li");
        ɵɵelementStart(13, "a", 7);
        ɵɵtext(14, "Privacy Policy");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(15, "li");
        ɵɵtext(16, "|");
        ɵɵelementEnd();
        ɵɵelementStart(17, "li");
        ɵɵelementStart(18, "a", 6);
        ɵɵtext(19, "Refunds & Cancellations");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵtextInterpolate1(" ", ctx.AppTitle, " ");
    } }, directives: [RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'lib-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }]; }, null); })();

class HomeComponent {
    constructor(environment) {
        this.environment = environment;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
    }
    ngOnInit() {
    }
}
HomeComponent.ɵfac = function HomeComponent_Factory(t) { return new (t || HomeComponent)(ɵɵdirectiveInject(EnvironmentService)); };
HomeComponent.ɵcmp = ɵɵdefineComponent({ type: HomeComponent, selectors: [["app-home"]], decls: 312, vars: 9, consts: [[1, "secone_wrapper"], [1, "secone"], [1, "d-flex", "justify-content-center"], [1, "brndintro"], [1, "card", "bg-none", "border-0"], ["alt", "login-logo", "width", "420px", 1, "img-fluid", "mx-auto", "d-block", 3, "src"], ["data-wow-delay", "300ms", "data-wow-duration", "4s", 1, "company-name", "wow", "zoomIn"], ["data-wow-delay", "300ms", "data-wow-duration", "4s", 1, "tagline", "text-white", "hite", "wow", "zoomIn"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", "id", "about", 1, "sectwo", "wow", "fadeInLeft"], [1, "bg1"], [1, "container"], [1, "row", "mx-0"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", 1, "col-12", "col-lg-7", "wow", "fadeInLeft"], [3, "translate"], ["href", "/ourStory#journey", 1, "learnMore", 3, "translate"], ["id", "heritage", 1, "secthree"], [1, "timeline", "d-none", "d-md-block"], [1, "d-flex", "justify-content-between"], [1, "d-flex", "flex-column", "text-center", "position-relative"], ["for", ""], ["id", "btn1", "type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "bottom", "data-content", "Mr. Dinesh Shah & Mr. Chinu Doshi began their partnership by pursuing rough trading in Surat.\n                        ", 1, "btn", "bg-none", "redline", "oval1", "active"], ["src", "./assets/images/white_diamond.png", "alt", ""], ["wfd-id", "87", 1, "nopopover", "option1"], ["wfd-id", "88", 1, "card"], ["wfd-id", "89", 1, "card-body"], ["type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "top", "data-content", "Mr. Dinesh Shah went to Belgium, Antwerp for acquiring rough. Resulting in tremendous growth in the firms early years. \n                        ", 1, "btn", "bg-none"], ["wfd-id", "82", 1, "nopopover", "option2"], ["wfd-id", "83", 1, "card"], ["wfd-id", "84", 1, "card-body"], ["type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "bottom", "data-content", "Transition from Lucky Diamond to C.Dinesh & Co partnership firm in Mumbai. An export import business in rough diamonds. \n                        ", 1, "btn", "bg-none", "redline"], ["wfd-id", "77", 1, "nopopover", "option1"], ["wfd-id", "78", 1, "card"], ["wfd-id", "79", 1, "card-body"], ["type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "top", "data-content", "Established the company's first office at Panchratana in Mumbai. \n                        ", 1, "btn", "bg-none"], ["wfd-id", "72", 1, "nopopover", "option2"], ["wfd-id", "73", 1, "card"], ["wfd-id", "74", 1, "card-body"], ["type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "bottom", "data-content", " C.Dinesh & Co strengthened their team with Mr. Jigar Doshi, Mr. Amit Doshi, Mr. Yomesh Shah & Mr Jaimin Shah entering day to day activities. \n                        ", 1, "btn", "bg-none", "redline"], ["wfd-id", "67", 1, "nopopover", "option1"], ["wfd-id", "68", 1, "card"], ["wfd-id", "69", 1, "card-body"], ["type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "top", "data-content", " Inception of Aura Jewels, expanding into the jewellery sector. Aura is \n                        a jewellery manufacturing firm based out of Mumbai.", 1, "btn", "bg-none"], ["wfd-id", "62", 1, "nopopover", "option2"], ["wfd-id", "63", 1, "card"], ["wfd-id", "64", 1, "card-body"], ["type", "button", "data-container", "body", "data-toggle", "popover", "data-placement", "bottom", "data-content", "Hired the 500th employee at the Surat Manufacturing Factory", 1, "btn", "bg-none", "oval2"], ["wfd-id", "57", 1, "nopopover", "option1"], ["wfd-id", "58", 1, "card"], ["wfd-id", "59", 1, "card-body"], ["id", "services", 1, "secfour"], [1, "mx-auto"], [1, "row", "justify-content-between"], ["data-wow-delay", "300ms", "data-wow-duration", "1s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-md-3", "pb-5", "pb-md-0", "wow", "slideInRight"], [1, "card-img"], ["src", "./assets/images/source.png", "alt", ""], ["data-wow-delay", "300ms", "data-wow-duration", "2s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-md-3", "pb-5", "pb-md-0", "wow", "slideInRight"], ["src", "./assets/images/internet-01.png", "alt", ""], ["data-wow-delay", "300ms", "data-wow-duration", "3s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-md-3", "pb-5", "pb-md-0", "wow", "slideInRight"], ["src", "./assets/images/internet-02.png", "alt", ""], ["data-wow-delay", "300ms", "data-wow-duration", "4s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-md-3", "wow", "slideInRight"], ["src", "./assets/images/internet-03.png", "alt", ""], [1, "row", "secCardgroup", "justify-content-around"], ["data-wow-delay", "300ms", "data-wow-duration", "1s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-sm-2", "wow", "slideInLeft"], ["href", "#"], ["src", "assets/images/primary-suplier.png", "alt", "", 1, "img-fluid"], ["src", "./assets/images/gia-emblem.png", "alt", ""], ["data-wow-delay", "300ms", "data-wow-duration", "2s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-sm-2", "wow", "slideInLeft"], ["src", "./assets/images/igi.png", "alt", ""], ["data-wow-delay", "300ms", "data-wow-duration", "3s", 1, "card", "bg-none", "border-0", "text-center", "col-12", "col-sm-2", "wow", "slideInLeft"], [1, "card-img", 2, "height", "111px"], ["src", "./assets/images/GCal8X.png", "alt", ""], ["src", "assets/images/sarine-jwells.png", "alt", "", 1, "img-fluid"], [1, "text-white", "text-capitalize", "caption", "d-block"], [1, "text-capitalize"], [1, "wrapper"], [1, "secfive"], [1, "row", "cardgroups"], ["data-wow-duration", "3s", "data-wow-delay", "300ms", 1, "col-12", "col-md-4", "mb-4", "mb-md-0", "wow", "zoomIn"], [1, "card", "bg-none", "border-0", "hover01"], ["src", "./assets/images/journey.jpg", "alt", "Card image cap", 1, "img-fluid"], [1, "card-body"], [1, "card-text"], ["href", "/ourStory#journey", 1, "readMore"], ["src", "./assets/images/cut.jpg", "alt", "Card image cap", 1, "img-fluid"], ["href", "/ourStory#beyoundCut", 1, "readMore"], ["data-wow-duration", "3s", "data-wow-delay", "300ms", 1, "col-12", "col-md-4", "wow", "zoomIn"], ["src", "./assets/images/technology.png", "alt", "Card image cap", 1, "img-fluid"], ["href", "/ourStory#tech", 1, "readMore"], [1, "row"], ["data-wow-duration", "3s", "data-wow-delay", "300ms", 1, "col-12", "text-lg-center", "wow", "zoomIn"], ["href", "/ourStory#csr", 1, "ourcsr-btn"], ["id", "contact", 1, "secsix"], [1, "row", "align-items-center", "justify-content-between"], ["data-wow-duration", "3s", "data-wow-delay", "300ms", 1, "col-12", "col-md-6", "mb-4", "mb-md-0", "wow", "fadeInLeft"], ["src", "assets/images/Cdinesh-map.png", "alt", "worldmap", 1, "img-fluid"], ["data-wow-duration", "3s", "data-wow-delay", "300ms", 1, "col-12", "col-md-6", "wow", "fadeInRight"], ["action", "", 1, "getintouchform"], [1, "col-6"], [1, "form-group", "m-0"], ["type", "text", "id", "firstname", "aria-describedby", "firstname", "placeholder", "First Name", 1, "form-control", "bg-none"], ["type", "text", "id", "lastname", "aria-describedby", "emailHelp", "placeholder", "Last Name", 1, "form-control", "bg-none"], ["type", "email", "id", "exampleInputEmail1", "aria-describedby", "emailHelp", "placeholder", "Email Address", 1, "form-control", "bg-none"], [1, "form-group"], ["id", "exampleFormControlTextarea1", "rows", "2", "placeholder", "Message", 1, "form-control", "bg-none"], [1, "d-flex", "justify-content-center", "justify-content-md-end"], ["type", "submit", 1, "getintouchform-submit", "bg-none"], [1, "secseven"], [1, "row", "justify-content-around", "r1", "align-items-center"], [1, "col-12", "col-md-4"], [1, "custcard", "text-center"], ["href", "tel:+91-22 43000300"], [1, "d-none", "d-md-block"], ["src", "./assets/images/vertical-line.png", "alt", ""], ["href", "tel:+00852 6531 2704"], [1, "row", "justify-content-around", "r1", "align-items-center", 2, "padding-top", "40px"], ["href", "tel:+32 3 232 13 42"], ["href", "tsel:+919316438156"]], template: function HomeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "lib-header");
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "section", 1);
        ɵɵelementStart(3, "div", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "div", 4);
        ɵɵelement(6, "img", 5);
        ɵɵelementStart(7, "p", 6);
        ɵɵtext(8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "i");
        ɵɵelementStart(10, "h4", 7);
        ɵɵtext(11, "Diamonds Beyond Imagination");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "section", 8);
        ɵɵelementStart(13, "div", 9);
        ɵɵelementStart(14, "div", 10);
        ɵɵelementStart(15, "div", 11);
        ɵɵelementStart(16, "div", 12);
        ɵɵelementStart(17, "h1", 13);
        ɵɵtext(18, "about us");
        ɵɵelementEnd();
        ɵɵelementStart(19, "p");
        ɵɵelementStart(20, "span", 13);
        ɵɵtext(21, "Established in 1976, ");
        ɵɵelementEnd();
        ɵɵelementStart(22, "span");
        ɵɵtext(23);
        ɵɵelementEnd();
        ɵɵelementStart(24, "span", 13);
        ɵɵtext(25, " is a Diamond Manufacturing firm based out of Mumbai and Suratt with their marketing associate offices in HongKong and Belgium.");
        ɵɵelementEnd();
        ɵɵelement(26, "br");
        ɵɵelement(27, "br");
        ɵɵelementStart(28, "span", 13);
        ɵɵtext(29, " The founders of the company are Mr. Chinubhai Doshi & Mr. Dineshbhai Shah. They paved and set the stones for the company, and were then supported in their journey by for Mr. Jigar Doshi, Mr. Amit Doshi, Mr. Yomesh Shah & Mr Jaimin Shah. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(30, "p", 13);
        ɵɵtext(31, "Diamonds Beyond Imagination\u2019 has resonated with our C. Dinesh family, for over 4 decades. Where we strive to go beyond our customers' expectations. Yearning to achieve continuous growth and improvement, along with our deep rooted traditions and values, today we have developed tremendous goodwill in the industry. ");
        ɵɵelementEnd();
        ɵɵelementStart(32, "a", 14);
        ɵɵtext(33, "Learn More");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(34, "div", 10);
        ɵɵelementStart(35, "section", 15);
        ɵɵelementStart(36, "h1");
        ɵɵtext(37, "Beyond heritage");
        ɵɵelementEnd();
        ɵɵelementStart(38, "div", 16);
        ɵɵelementStart(39, "div", 17);
        ɵɵelementStart(40, "div", 18);
        ɵɵelementStart(41, "label", 19);
        ɵɵtext(42, "1969");
        ɵɵelementEnd();
        ɵɵelementStart(43, "button", 20);
        ɵɵelement(44, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(45, "div", 22);
        ɵɵelementStart(46, "div", 23);
        ɵɵelementStart(47, "div", 24);
        ɵɵelementStart(48, "p");
        ɵɵtext(49, " Mr. Dinesh Shah & Mr. Chinu Doshi began their partnership by pursuing rough trading in Surat. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(50, "div", 18);
        ɵɵelementStart(51, "button", 25);
        ɵɵelement(52, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(53, "label", 19);
        ɵɵtext(54, "1973");
        ɵɵelementEnd();
        ɵɵelementStart(55, "div", 26);
        ɵɵelementStart(56, "div", 27);
        ɵɵelementStart(57, "div", 28);
        ɵɵelementStart(58, "p");
        ɵɵtext(59, " Mr. Dinesh Shah went to Belgium, Antwerp for acquiring rough. Resulting in tremendous growth in the firms early years. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(60, "div", 18);
        ɵɵelementStart(61, "label", 19);
        ɵɵtext(62, "1976");
        ɵɵelementEnd();
        ɵɵelementStart(63, "button", 29);
        ɵɵelement(64, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(65, "div", 30);
        ɵɵelementStart(66, "div", 31);
        ɵɵelementStart(67, "div", 32);
        ɵɵelementStart(68, "p");
        ɵɵtext(69, " Transition from Lucky Diamond to C.Dinesh & Co partnership firm in Mumbai. An export import business in rough diamonds. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(70, "div", 18);
        ɵɵelementStart(71, "button", 33);
        ɵɵelement(72, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(73, "label", 19);
        ɵɵtext(74, "1980");
        ɵɵelementEnd();
        ɵɵelementStart(75, "div", 34);
        ɵɵelementStart(76, "div", 35);
        ɵɵelementStart(77, "div", 36);
        ɵɵelementStart(78, "p");
        ɵɵtext(79, " Established the company's first office at Panchratana in Mumbai. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(80, "div", 18);
        ɵɵelementStart(81, "label", 19);
        ɵɵtext(82, "1996");
        ɵɵelementEnd();
        ɵɵelementStart(83, "button", 37);
        ɵɵelement(84, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(85, "div", 38);
        ɵɵelementStart(86, "div", 39);
        ɵɵelementStart(87, "div", 40);
        ɵɵelementStart(88, "p");
        ɵɵtext(89, " C.Dinesh & Co strengthened their team with Mr. Jigar Doshi, Mr. Amit Doshi, Mr. Yomesh Shah & Mr Jaimin Shah entering day to day activities. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(90, "div", 18);
        ɵɵelementStart(91, "button", 41);
        ɵɵelement(92, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(93, "label", 19);
        ɵɵtext(94, "2007");
        ɵɵelementEnd();
        ɵɵelementStart(95, "div", 42);
        ɵɵelementStart(96, "div", 43);
        ɵɵelementStart(97, "div", 44);
        ɵɵelementStart(98, "p");
        ɵɵtext(99, " Inception of Aura Jewels, expanding into the jewellery sector. Aura is a jewellery manufacturing firm based out of Mumbai. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(100, "div", 18);
        ɵɵelementStart(101, "label", 19);
        ɵɵtext(102, "2016");
        ɵɵelementEnd();
        ɵɵelementStart(103, "button", 45);
        ɵɵelement(104, "img", 21);
        ɵɵelementEnd();
        ɵɵelementStart(105, "div", 46);
        ɵɵelementStart(106, "div", 47);
        ɵɵelementStart(107, "div", 48);
        ɵɵelementStart(108, "p");
        ɵɵtext(109, " Hired the 500th employee at the Surat Manufacturing Factory ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(110, "section", 49);
        ɵɵelementStart(111, "h1", 50);
        ɵɵtext(112, "Beyond services");
        ɵɵelementEnd();
        ɵɵelementStart(113, "div", 51);
        ɵɵelementStart(114, "div", 52);
        ɵɵelementStart(115, "div", 53);
        ɵɵelement(116, "img", 54);
        ɵɵelementEnd();
        ɵɵelementStart(117, "p");
        ɵɵelementStart(118, "span");
        ɵɵtext(119, "ethically");
        ɵɵelementEnd();
        ɵɵtext(120, "Sourced");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(121, "div", 55);
        ɵɵelementStart(122, "div", 53);
        ɵɵelement(123, "img", 56);
        ɵɵelementEnd();
        ɵɵelementStart(124, "p");
        ɵɵelementStart(125, "span");
        ɵɵtext(126, "worldwide");
        ɵɵelementEnd();
        ɵɵtext(127, "Shipping");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(128, "div", 57);
        ɵɵelementStart(129, "div", 53);
        ɵɵelement(130, "img", 58);
        ɵɵelementEnd();
        ɵɵelementStart(131, "p");
        ɵɵelementStart(132, "span");
        ɵɵtext(133, "24/7");
        ɵɵelementEnd();
        ɵɵtext(134, "Customer service");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(135, "div", 59);
        ɵɵelementStart(136, "div", 53);
        ɵɵelement(137, "img", 60);
        ɵɵelementEnd();
        ɵɵelementStart(138, "p");
        ɵɵelementStart(139, "span");
        ɵɵtext(140, "beyound brilliance");
        ɵɵelementEnd();
        ɵɵelement(141, "br");
        ɵɵtext(142, "in polishing every diamond");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(143, "div", 61);
        ɵɵelementStart(144, "div", 62);
        ɵɵelementStart(145, "div", 53);
        ɵɵelementStart(146, "a", 63);
        ɵɵelement(147, "img", 64);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(148, "p");
        ɵɵelementStart(149, "span");
        ɵɵtext(150, "rapnet");
        ɵɵelementEnd();
        ɵɵelement(151, "br");
        ɵɵtext(152, "Primary Suplier");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(153, "div", 62);
        ɵɵelementStart(154, "div", 53);
        ɵɵelementStart(155, "a", 63);
        ɵɵelement(156, "img", 65);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(157, "p");
        ɵɵelementStart(158, "span");
        ɵɵtext(159, "gia");
        ɵɵelementEnd();
        ɵɵtext(160, "Certified");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(161, "div", 66);
        ɵɵelementStart(162, "div", 53);
        ɵɵelement(163, "img", 67);
        ɵɵelementEnd();
        ɵɵelementStart(164, "a", 63);
        ɵɵelementStart(165, "p");
        ɵɵelementStart(166, "span");
        ɵɵtext(167, "igi");
        ɵɵelementEnd();
        ɵɵtext(168, "Certified");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(169, "div", 68);
        ɵɵelementStart(170, "div", 69);
        ɵɵelementStart(171, "a", 63);
        ɵɵelement(172, "img", 70);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(173, "p");
        ɵɵelementStart(174, "span");
        ɵɵtext(175, "GCAL");
        ɵɵelementEnd();
        ɵɵtext(176, "8X");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(177, "div", 68);
        ɵɵelementStart(178, "div", 53);
        ɵɵelementStart(179, "a", 63);
        ɵɵelement(180, "img", 71);
        ɵɵelementEnd();
        ɵɵelementStart(181, "span", 72);
        ɵɵtext(182, "diamond ");
        ɵɵelement(183, "br");
        ɵɵtext(184, "journey");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(185, "p", 73);
        ɵɵelementStart(186, "span", 73);
        ɵɵtext(187, "Official");
        ɵɵelementEnd();
        ɵɵtext(188, "Partner");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(189, "div", 74);
        ɵɵelementStart(190, "div", 10);
        ɵɵelementStart(191, "section", 75);
        ɵɵelementStart(192, "h1", 50);
        ɵɵtext(193, "DIAMONDS BEYOND IMAGINATION");
        ɵɵelementEnd();
        ɵɵelementStart(194, "div", 76);
        ɵɵelementStart(195, "div", 77);
        ɵɵelementStart(196, "div", 78);
        ɵɵelementStart(197, "a", 63);
        ɵɵelement(198, "img", 79);
        ɵɵelementEnd();
        ɵɵelementStart(199, "div", 80);
        ɵɵelementStart(200, "h4");
        ɵɵtext(201, "beyond journey");
        ɵɵelementEnd();
        ɵɵelementStart(202, "p", 81);
        ɵɵtext(203, "Our partnership with Sarine Diamond Journey helps us unfold the full traceability of a diamond\u2019s origin, giving retailers a powerful tool for driving sales among today\u2019s ethically-minded consumers. ");
        ɵɵelementEnd();
        ɵɵelementStart(204, "a", 82);
        ɵɵtext(205, "Read More");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(206, "div", 77);
        ɵɵelementStart(207, "div", 78);
        ɵɵelementStart(208, "a", 63);
        ɵɵelement(209, "img", 83);
        ɵɵelementEnd();
        ɵɵelementStart(210, "div", 80);
        ɵɵelementStart(211, "h4");
        ɵɵtext(212, "beyond cut");
        ɵɵelementEnd();
        ɵɵelementStart(213, "p", 81);
        ɵɵtext(214, " We believe that \u2018Every diamond has a unique story to tell\u2019, a story that lives on forever and we thus, make it our goal to go beyond the industry norms and provide our customers with the story of every diamond; right from its origin, deep within the earth's crust until it reaches their hands.");
        ɵɵelementEnd();
        ɵɵelementStart(215, "a", 84);
        ɵɵtext(216, "Read More");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(217, "div", 85);
        ɵɵelementStart(218, "div", 78);
        ɵɵelementStart(219, "a", 63);
        ɵɵelement(220, "img", 86);
        ɵɵelementEnd();
        ɵɵelementStart(221, "div", 80);
        ɵɵelementStart(222, "h4");
        ɵɵtext(223, "beyond technology");
        ɵɵelementEnd();
        ɵɵelementStart(224, "p", 81);
        ɵɵtext(225, "At C. Dinesh we understand the importance of the integration of technology. We are at the pinnacle of fusing decades of experience of our craftsmans with modern technology.");
        ɵɵelementEnd();
        ɵɵelementStart(226, "a", 87);
        ɵɵtext(227, "Read More");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(228, "div", 88);
        ɵɵelementStart(229, "div", 89);
        ɵɵelementStart(230, "a", 90);
        ɵɵtext(231, "Beyond csr");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(232, "section", 91);
        ɵɵelementStart(233, "h1", 50);
        ɵɵtext(234, "get in touch");
        ɵɵelementEnd();
        ɵɵelementStart(235, "div", 92);
        ɵɵelementStart(236, "div", 93);
        ɵɵelement(237, "img", 94);
        ɵɵelementEnd();
        ɵɵelementStart(238, "div", 95);
        ɵɵelementStart(239, "form", 96);
        ɵɵelementStart(240, "p");
        ɵɵtext(241, " Fill out the form below and get in touch with our team");
        ɵɵelementEnd();
        ɵɵelementStart(242, "div", 88);
        ɵɵelementStart(243, "div", 97);
        ɵɵelementStart(244, "div", 98);
        ɵɵelement(245, "input", 99);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(246, "div", 97);
        ɵɵelementStart(247, "div", 98);
        ɵɵelement(248, "input", 100);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(249, "div", 98);
        ɵɵelement(250, "input", 101);
        ɵɵelementEnd();
        ɵɵelementStart(251, "div", 102);
        ɵɵelement(252, "textarea", 103);
        ɵɵelementEnd();
        ɵɵelementStart(253, "div", 104);
        ɵɵelementStart(254, "button", 105);
        ɵɵtext(255, "submit");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(256, "section", 106);
        ɵɵelementStart(257, "div", 107);
        ɵɵelementStart(258, "div", 108);
        ɵɵelementStart(259, "div", 109);
        ɵɵelementStart(260, "h4");
        ɵɵtext(261, "Mumbai");
        ɵɵelementEnd();
        ɵɵelementStart(262, "h3");
        ɵɵtext(263, "head office");
        ɵɵelementEnd();
        ɵɵelementStart(264, "p");
        ɵɵtext(265, "DC-2080 Bharat Diamond Bourse, Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra 400051");
        ɵɵelementEnd();
        ɵɵelementStart(266, "a", 110);
        ɵɵtext(267, "+91-22 43000300");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(268, "div", 111);
        ɵɵelement(269, "img", 112);
        ɵɵelementEnd();
        ɵɵelementStart(270, "div", 108);
        ɵɵelementStart(271, "div", 109);
        ɵɵelementStart(272, "h4");
        ɵɵtext(273, "hong Kong");
        ɵɵelementEnd();
        ɵɵelementStart(274, "h3");
        ɵɵtext(275, "Marketing Associate");
        ɵɵelementEnd();
        ɵɵelementStart(276, "p");
        ɵɵtext(277, "Fotune Fook Ltd 8/F, Beverly Commercial Center 87-105 Chatham Road South, Tsim Sha Tsui, Kowloon, Hong Kong ");
        ɵɵelementEnd();
        ɵɵelementStart(278, "a", 113);
        ɵɵtext(279, "+00852 6531 2704");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(280, "div", 114);
        ɵɵelementStart(281, "div", 108);
        ɵɵelementStart(282, "div", 109);
        ɵɵelementStart(283, "h4");
        ɵɵtext(284, "Belgium");
        ɵɵelementEnd();
        ɵɵelementStart(285, "h3");
        ɵɵtext(286, "Marketing Associate");
        ɵɵelementEnd();
        ɵɵelementStart(287, "p");
        ɵɵtext(288, "HABERKORN & SONS (A) BVBA,2018 ANTWERPEN PELIKAANSTRAAT 78 BOX 99 , ");
        ɵɵelement(289, "br");
        ɵɵtext(290, "ANTWERP DIAMOND BOURSE ");
        ɵɵelement(291, "br");
        ɵɵtext(292, "OFFICE 905 ");
        ɵɵelementEnd();
        ɵɵelementStart(293, "a", 115);
        ɵɵtext(294, "+32 3 232 13 42");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(295, "div", 111);
        ɵɵelement(296, "img", 112);
        ɵɵelementEnd();
        ɵɵelementStart(297, "div", 108);
        ɵɵelementStart(298, "div", 109);
        ɵɵelementStart(299, "h4");
        ɵɵtext(300, "Surat");
        ɵɵelementEnd();
        ɵɵelementStart(301, "h3");
        ɵɵtext(302, " Head Factory");
        ɵɵelementEnd();
        ɵɵelementStart(303, "p");
        ɵɵtext(304, "NITA EXPORT BUILDING, BOMBAY FOOD COMPOUND, ");
        ɵɵelement(305, "br");
        ɵɵtext(306, "\nSWAMI PARAMANAND MARG, NR. KATARGAM KASHA NAGAR BRTS BUS STAND, KASHA NAGAR,");
        ɵɵelement(307, "br");
        ɵɵtext(308, " NEAR YES BANK, SURAT-395004, GUJARAT. ");
        ɵɵelementEnd();
        ɵɵelementStart(309, "a", 116);
        ɵɵtext(310, "+919316438156");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(311, "lib-footer");
    } if (rf & 2) {
        ɵɵadvance(6);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(9);
        ɵɵproperty("translate", "home.about.title");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.about.description.line1");
        ɵɵadvance(3);
        ɵɵtextInterpolate1(" ", ctx.AppTitle, " ");
        ɵɵadvance(1);
        ɵɵproperty("translate", "home.about.description.line1.1");
        ɵɵadvance(4);
        ɵɵproperty("translate", "home.about.description.line2");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.about.description.line3");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.about.description.learnMore");
    } }, directives: [HeaderComponent, TranslateDirective, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, FooterComponent], styles: [".secone_wrapper[_ngcontent-%COMP%]{background-image:linear-gradient(#23599e,#1a2b4a)!important}.img-fluid[_ngcontent-%COMP%]{width:100%}@media screen and (max-width:1600px) and (min-width:320px) and (orientation:landscape){.brndintro[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:200px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HomeComponent, [{
        type: Component,
        args: [{
                selector: 'app-home',
                templateUrl: './home.component.html',
                styleUrls: ['./home.component.scss']
            }]
    }], function () { return [{ type: EnvironmentService }]; }, null); })();

class NavigationComponent {
    constructor() { }
    ngOnInit() {
    }
}
NavigationComponent.ɵfac = function NavigationComponent_Factory(t) { return new (t || NavigationComponent)(); };
NavigationComponent.ɵcmp = ɵɵdefineComponent({ type: NavigationComponent, selectors: [["app-navigation"]], decls: 0, vars: 0, template: function NavigationComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NavigationComponent, [{
        type: Component,
        args: [{
                selector: 'app-navigation',
                templateUrl: './navigation.component.html',
                styleUrls: ['./navigation.component.scss']
            }]
    }], function () { return []; }, null); })();

class OurStoryComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
OurStoryComponent.ɵfac = function OurStoryComponent_Factory(t) { return new (t || OurStoryComponent)(); };
OurStoryComponent.ɵcmp = ɵɵdefineComponent({ type: OurStoryComponent, selectors: [["lib-our-story"]], decls: 90, vars: 0, consts: [[1, "wrapper"], [1, "content"], ["data-wow-delay", "300ms", "data-wow-duration", "4s", "id", "journey", 1, "one", "wow", "fadeInLeft"], [1, "bg1"], [1, "container"], [1, "row", "mx-0"], ["data-wow-delay", "300ms", "data-wow-duration", "4s", 1, "col-12", "col-lg-7", "wow", "fadeInLeft"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", "id", "beyoundCut", 1, "two", "position-relative", "wow", "fadeInRight"], [1, "bg2"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", 1, "col-12", "col-lg-6", "ml-auto", "wow", "fadeInRight"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", "id", "tech", 1, "three", "wow", "fadeInLeft"], [1, "bg3"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", 1, "col-12", "col-lg-7", "wow", "fadeInLeft"], [1, "overview"], ["routerLink", "/inventory/search", 1, "btn-bynow"], ["data-wow-delay", "300ms", "data-wow-duration", "3s", "id", "csr", 1, "four", "position-relative", "wow", "fadeInRight"], [1, "bg4"]], template: function OurStoryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "lib-header");
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "section", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "div", 6);
        ɵɵelementStart(8, "h1");
        ɵɵtext(9, "Beyond journey");
        ɵɵelementEnd();
        ɵɵelementStart(10, "p");
        ɵɵelementStart(11, "span");
        ɵɵtext(12, " It is our goal to go beyond the rest and provide our customers with the story of every diamond, from its origin deep within the earth's crust till it reaches their hands. We are proud to announce our partnership with Sarine Diamond Journey \u2122. ");
        ɵɵelementEnd();
        ɵɵelement(13, "br");
        ɵɵtext(14, " C.Dinesh & Co. is 1 of 23 companies in the world to embark on this journey with Sarine. With our ethical sourcing and the help of Sarine the worldwide leader in diamond technologies and gemstone production to provide the Diamond Journey \u2122 report. ");
        ɵɵelementEnd();
        ɵɵelementStart(15, "p");
        ɵɵtext(16, "Together we will help unfold the story of every diamond. Whose origin began millions of years ago deep in the earth's crust. To the mine's surface. To the craftsman hands who brings out the diamonds' best character. With the help of Sarine we will offer full traceability of a diamond\u2019s origin, giving retailers a powerful tool for driving sales among today\u2019s ethically-minded consumers. We Procure only Ethically-sourced Rough Diamonds through the open market from reputable mines DTC, Argyle, Rio Tinto, Ekati, Dominion Diamond Mines, Lucara, Diamdel. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "section", 7);
        ɵɵelementStart(18, "div", 8);
        ɵɵelementStart(19, "div", 4);
        ɵɵelementStart(20, "div", 5);
        ɵɵelementStart(21, "div", 9);
        ɵɵelementStart(22, "h1");
        ɵɵtext(23, "Beyond craftmanship");
        ɵɵelementEnd();
        ɵɵelementStart(24, "p");
        ɵɵelementStart(25, "span");
        ɵɵtext(26, "At C. Dinesh it is our commitment to be on the forefront of craftsmanship and art.");
        ɵɵelementEnd();
        ɵɵelement(27, "br");
        ɵɵtext(28, " Over our 44 year history, it has been our mission to produce diamond cuts that have the highest fire and brilliance. Right from planning to polishing, utmost importance is given to every facet our craftsmen lay their expertise on.");
        ɵɵelementEnd();
        ɵɵelementStart(29, "p");
        ɵɵtext(30, " We our proud to showcase to the world our capabilities in producing Heart & Arrow diamonds, with the highest precision. Our craftsmen have the artistry and prowess to create diamonds of all shapes Round, Princess, Oval, Marquise, Pear, Cushion, Emerald, Asscher, Radiant, Sq. Radiant, Heart. ");
        ɵɵelementEnd();
        ɵɵelementStart(31, "p");
        ɵɵtext(32, "These craftsmen are pivotal part of our organization, most of them have dedicated their entire lives into not just creating a diamond but a story of a gemstone that will live on forever.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(33, "div", 0);
        ɵɵelementStart(34, "div", 1);
        ɵɵelementStart(35, "section", 10);
        ɵɵelementStart(36, "div", 11);
        ɵɵelementStart(37, "div", 4);
        ɵɵelementStart(38, "div", 5);
        ɵɵelementStart(39, "div", 12);
        ɵɵelementStart(40, "h1");
        ɵɵtext(41, "Beyond technology");
        ɵɵelementEnd();
        ɵɵelementStart(42, "p");
        ɵɵelementStart(43, "span");
        ɵɵtext(44, " At C.Dinesh we understand the importance of the integration of technology. We are at the pinnacle of fusing decades of experience of our craftsmans with modern technology. This enables the firm in being highly efficient while creating diamonds of the highest quality. ");
        ɵɵelementEnd();
        ɵɵelement(45, "br");
        ɵɵelementEnd();
        ɵɵelementStart(46, "p");
        ɵɵtext(47, " We use the latest technologies from Sarine to help us with manufacturing. All our diamonds are planned by the aid of the industry revolutionizing Galaxy 1000 Machines. We also have incorporated the use of the Synova Diamond Laser Machine. Every employee at our factory undergoes rigorous training enabling them to not only be skilled in the current ways on manufacturing but able to adapt to any technological advances of the future. ");
        ɵɵelementEnd();
        ɵɵelementStart(48, "div", 13);
        ɵɵelementStart(49, "h4");
        ɵɵtext(50, " product overview");
        ɵɵelementEnd();
        ɵɵelementStart(51, "p");
        ɵɵelementStart(52, "span");
        ɵɵtext(53, "Size :");
        ɵɵelementEnd();
        ɵɵtext(54, " 0.30 ct to 25.00 ct");
        ɵɵelement(55, "br");
        ɵɵelementStart(56, "span");
        ɵɵtext(57, "Shapes :");
        ɵɵelementEnd();
        ɵɵtext(58, " We specialize mainly in Rounds, Princess, Cushions & we also deal in other fancy shapes like Pear, Oval, Marquise, Heart, Emerald, Square Emerald, Asscher, Square Radiant,");
        ɵɵelement(59, "br");
        ɵɵelementStart(60, "span");
        ɵɵtext(61, "Colour :");
        ɵɵelementEnd();
        ɵɵtext(62, " D to M and Fancy Color");
        ɵɵelement(63, "br");
        ɵɵelementStart(64, "span");
        ɵɵtext(65, "Clarity :");
        ɵɵelementEnd();
        ɵɵtext(66, " IF to I2");
        ɵɵelement(67, "br");
        ɵɵelementStart(68, "span");
        ɵɵtext(69, "Cut :");
        ɵɵelementEnd();
        ɵɵtext(70, " High standards of Cut, Polish & Symmetry ");
        ɵɵelementEnd();
        ɵɵelementStart(71, "a", 14);
        ɵɵtext(72, "Buy Now");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(73, "section", 15);
        ɵɵelementStart(74, "div", 16);
        ɵɵelementStart(75, "div", 4);
        ɵɵelementStart(76, "div", 5);
        ɵɵelementStart(77, "div", 9);
        ɵɵelementStart(78, "h1");
        ɵɵtext(79, "Beyond csr");
        ɵɵelementEnd();
        ɵɵelementStart(80, "p");
        ɵɵelementStart(81, "span");
        ɵɵtext(82, "Our founder Mr. Dinesh Shah at a young age started working at the Kinara Shop his father owned in his ancestral village Thalvada.");
        ɵɵelementEnd();
        ɵɵelement(83, "br");
        ɵɵtext(84, " During this phase of his life he faced a lot of hardships for basic necessities such as access to healthcare and education. It was his vision in life to always give back to the community and the people who helped him in his journey to success.");
        ɵɵelementEnd();
        ɵɵelementStart(85, "p");
        ɵɵtext(86, " He is the Founding Father of Smt. H A Shah General Hospital in Satlasana, that he named after his mother. The Hospital was established in 1992. The hospital treats on average 40,000 people every year. It has become the primary source for healthcare for the surrounding 20 villages. Till date it has provided Cataract surgery to 30,000 people for free of cost.");
        ɵɵelementEnd();
        ɵɵelementStart(87, "p");
        ɵɵtext(88, " AM Shah High School in Thalvada, is another initiative by Mr. Dinesh Shah founded in 1999. The High School provides free education for all students between 9th to 12th grade. A Devotee of Jainism, we have also established Dharamshalas in Ayodhyapuram, Nageshwar and Upashres in Thalvada and Ayodhyapuram. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(89, "lib-footer");
    } }, directives: [HeaderComponent, RouterLinkWithHref, FooterComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OurStoryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-our-story',
                templateUrl: './our-story.component.html',
                styleUrls: ['./our-story.component.css']
            }]
    }], function () { return []; }, null); })();

class PrivacyComponent {
    constructor(environment) {
        this.environment = environment;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
        this.AppName = environment.AppName;
    }
    ngOnInit() {
    }
}
PrivacyComponent.ɵfac = function PrivacyComponent_Factory(t) { return new (t || PrivacyComponent)(ɵɵdirectiveInject(EnvironmentService)); };
PrivacyComponent.ɵcmp = ɵɵdefineComponent({ type: PrivacyComponent, selectors: [["lib-privacy"]], decls: 161, vars: 64, consts: [[1, "wrapper", "privacy"], [1, "container"], [1, "pricavysec1"], [1, "row"], [1, "col-12"], [3, "translate"], [1, "text-content"], [1, "text-content", 3, "translate"], ["href", "#", 3, "translate"], [1, "pricavysec3"], ["href", "mailto:cdinesh@cdinesh.com", "target", "_blank", 3, "translate"], [1, "pricavysec2"], [1, "", 3, "translate"]], template: function PrivacyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "lib-header");
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "section", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "h1", 5);
        ɵɵtext(7, "Privacy policy");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 4);
        ɵɵelementStart(9, "p", 6);
        ɵɵtext(10);
        ɵɵelementStart(11, "span", 5);
        ɵɵtext(12, "built the");
        ɵɵelementEnd();
        ɵɵtext(13);
        ɵɵelementStart(14, "span", 5);
        ɵɵtext(15, " app as a Free app. This SERVICE is provided by ");
        ɵɵelementEnd();
        ɵɵtext(16);
        ɵɵelementStart(17, "span", 5);
        ɵɵtext(18, " at no cost and is intended for use as is.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(19, "p", 7);
        ɵɵtext(20, " This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service. ");
        ɵɵelementEnd();
        ɵɵelementStart(21, "p", 7);
        ɵɵtext(22, " If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy. ");
        ɵɵelementEnd();
        ɵɵelementStart(23, "p", 6);
        ɵɵelementStart(24, "span", 5);
        ɵɵtext(25, " The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at ");
        ɵɵelementEnd();
        ɵɵtext(26);
        ɵɵelementStart(27, "span", 5);
        ɵɵtext(28, " unless otherwise defined in this Privacy Policy.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(29, "div", 4);
        ɵɵelementStart(30, "h4", 5);
        ɵɵtext(31, "Information Collection and Use");
        ɵɵelementEnd();
        ɵɵelementStart(32, "p", 7);
        ɵɵtext(33, " For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to Internet Connection status. The information that we request will be retained by us and used as described in this privacy policy. ");
        ɵɵelementEnd();
        ɵɵelementStart(34, "p", 7);
        ɵɵtext(35, " The app does use third party services that may collect information used to identify you. ");
        ɵɵelementEnd();
        ɵɵelementStart(36, "p");
        ɵɵelementStart(37, "small", 5);
        ɵɵtext(38, "Link to privacy policy of third party service providers used by the app");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(39, "p");
        ɵɵelementStart(40, "a", 8);
        ɵɵtext(41, "Google Play Services");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(42, "div", 4);
        ɵɵelementStart(43, "h4", 5);
        ɵɵtext(44, "Log Data");
        ɵɵelementEnd();
        ɵɵelementStart(45, "p", 7);
        ɵɵtext(46, " We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (\u201CIP\u201D) address, device name, operating system version, the configuration of the app when utilising our Service, the time and date of your use of the Service, and other statistics. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(47, "div", 4);
        ɵɵelementStart(48, "h4", 5);
        ɵɵtext(49, "Cookies");
        ɵɵelementEnd();
        ɵɵelementStart(50, "p", 7);
        ɵɵtext(51, " Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory. ");
        ɵɵelementEnd();
        ɵɵelementStart(52, "p", 7);
        ɵɵtext(53, " This Service does not use these \u201Ccookies\u201D explicitly. However, the app may use third party code and libraries that use \u201Ccookies\u201D to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(54, "div", 4);
        ɵɵelementStart(55, "h4", 5);
        ɵɵtext(56, "Service Providers");
        ɵɵelementEnd();
        ɵɵelementStart(57, "ul", 5);
        ɵɵtext(58, "We may employ third-party companies and individuals due to the following reasons: ");
        ɵɵelementStart(59, "li", 5);
        ɵɵtext(60, "To facilitate our Service;");
        ɵɵelementEnd();
        ɵɵelementStart(61, "li", 5);
        ɵɵtext(62, "To provide the Service on our behalf;");
        ɵɵelementEnd();
        ɵɵelementStart(63, "li", 5);
        ɵɵtext(64, "To perform Service-related services; or");
        ɵɵelementEnd();
        ɵɵelementStart(65, "li", 5);
        ɵɵtext(66, "To assist us in analysing how our Service is used.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(67, "p", 7);
        ɵɵtext(68, " We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(69, "div", 4);
        ɵɵelementStart(70, "h4", 5);
        ɵɵtext(71, "Security");
        ɵɵelementEnd();
        ɵɵelementStart(72, "p", 7);
        ɵɵtext(73, " We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(74, "div", 4);
        ɵɵelementStart(75, "h4", 5);
        ɵɵtext(76, "Links to Other Sites");
        ɵɵelementEnd();
        ɵɵelementStart(77, "p", 7);
        ɵɵtext(78, " This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(79, "div", 4);
        ɵɵelementStart(80, "h4", 5);
        ɵɵtext(81, "Children\u2019s Privacy");
        ɵɵelementEnd();
        ɵɵelementStart(82, "p", 7);
        ɵɵtext(83, " These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(84, "div", 4);
        ɵɵelementStart(85, "h4", 5);
        ɵɵtext(86, "Changes to This Privacy Policy");
        ɵɵelementEnd();
        ɵɵelementStart(87, "p", 7);
        ɵɵtext(88, " We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(89, "div", 4);
        ɵɵelementStart(90, "h4", 5);
        ɵɵtext(91, "Contact Us");
        ɵɵelementEnd();
        ɵɵelementStart(92, "p", 7);
        ɵɵtext(93, " If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(94, "section", 9);
        ɵɵelementStart(95, "div", 3);
        ɵɵelementStart(96, "div", 4);
        ɵɵelementStart(97, "h1", 5);
        ɵɵtext(98, " Policies, Grievance Mechanism & Compliance Reporting");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(99, "div", 4);
        ɵɵelementStart(100, "p", 7);
        ɵɵtext(101, " We are committed to ethical business practices, responsible sourcing, human rights protection, and full regulatory compliance. The following policies, grievance mechanism, and reports are implemented within our organization to ensure transparency, accountability, and continuous improvement. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(102, "div", 4);
        ɵɵelementStart(103, "h4", 5);
        ɵɵtext(104, "Policies");
        ɵɵelementEnd();
        ɵɵelementStart(105, "p", 7);
        ɵɵtext(106, " All key corporate policies, including Human Rights, Labour Practices, Responsible Sourcing, Business Ethics, Environmental Protection, Product Integrity, Health & Safety, and Financial Compliance, are in place and actively followed. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(107, "div", 4);
        ɵɵelementStart(108, "h4", 5);
        ɵɵtext(109, "Grievance Mechanism");
        ɵɵelementEnd();
        ɵɵelementStart(110, "p", 7);
        ɵɵtext(111, " A structured grievance mechanism is established to address concerns related to workplace practices, human rights, and supply chain compliance in a fair and transparent manner. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(112, "div", 4);
        ɵɵelementStart(113, "h4", 5);
        ɵɵtext(114, "Annual Reporting");
        ɵɵelementEnd();
        ɵɵelementStart(115, "ul");
        ɵɵelementStart(116, "li", 7);
        ɵɵtext(117, " Annual Report on Responsible Sourcing & Due Diligence Mechanism (no risk identity) ");
        ɵɵelementEnd();
        ɵɵelementStart(118, "li", 7);
        ɵɵtext(119, " Annual Human Rights Report ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(120, "div", 4);
        ɵɵelementStart(121, "h4", 5);
        ɵɵtext(122, "Availability");
        ɵɵelementEnd();
        ɵɵelementStart(123, "p", 7);
        ɵɵtext(124, " All policies, grievance mechanism details, and annual compliance reports are available upon request. ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(125, "div", 4);
        ɵɵelementStart(126, "p", 7);
        ɵɵtext(127, " For any queries or document requests, please contact: ");
        ɵɵelementEnd();
        ɵɵelementStart(128, "div", 6);
        ɵɵelementStart(129, "b", 5);
        ɵɵtext(130, "Email:");
        ɵɵelementEnd();
        ɵɵelementStart(131, "a", 10);
        ɵɵtext(132, " cdinesh@cdinesh.com ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(133, "p", 6);
        ɵɵelementStart(134, "b", 5);
        ɵɵtext(135, "Phone:");
        ɵɵelementEnd();
        ɵɵelementStart(136, "span", 5);
        ɵɵtext(137, " +91 224300200");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(138, "section", 11);
        ɵɵelementStart(139, "div", 3);
        ɵɵelementStart(140, "div", 4);
        ɵɵelementStart(141, "h1", 5);
        ɵɵtext(142, " GDPR Privacy Protection Regulation");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(143, "div", 4);
        ɵɵelementStart(144, "h4", 5);
        ɵɵtext(145, "Dear Customer,");
        ɵɵelementEnd();
        ɵɵelementStart(146, "p", 12);
        ɵɵtext(147, " As you may know, a new European privacy regulation called General Data Protection Regulation (\"GDPR\") will go into effect on May 25th. This new regulation is designed to unify the current data protection privacy laws throughout the EU, and to enhance the rights of European residents to protect their personal information. The GDPR also applies to any business that offers its products or services to European residents. ");
        ɵɵelementEnd();
        ɵɵelementStart(148, "p", 12);
        ɵɵtext(149, " You\u2019re registered and active member using our website and other services. ");
        ɵɵelementEnd();
        ɵɵelementStart(150, "p", 12);
        ɵɵtext(151, " As the General Data Protection & Regulation Act (GDPR) has come into effect, we also support the privacy policy and promise you that we will not share or sell your data outside our business or will not use for marketing purpose by third party. ");
        ɵɵelementEnd();
        ɵɵelementStart(152, "p", 12);
        ɵɵtext(153, " If you are EU (European Union) resident and dont want to keep our business relationship and dont want to hearing from us for upcoming diamonds events, diamond deals, diamond auctions you can opt out by sending us mail on following email id. ");
        ɵɵelementEnd();
        ɵɵelementStart(154, "p", 12);
        ɵɵtext(155, " You can also update your personal details any time by login to our website OR simply drop us a mail on amit@cdinesh.com and our respective sales executive will contact you within 5 working day and provide you the best solution. ");
        ɵɵelementEnd();
        ɵɵelementStart(156, "p", 12);
        ɵɵtext(157, " We really respect your privacy and trust with us ");
        ɵɵelementEnd();
        ɵɵelementStart(158, "p", 12);
        ɵɵtext(159, " Thank you ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(160, "lib-footer");
    } if (rf & 2) {
        ɵɵadvance(6);
        ɵɵproperty("translate", "home.privacy.title");
        ɵɵadvance(4);
        ɵɵtextInterpolate1(" ", ctx.AppTitle, " ");
        ɵɵadvance(1);
        ɵɵproperty("translate", "home.privacy.line1.span1");
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ctx.AppName, " ");
        ɵɵadvance(1);
        ɵɵproperty("translate", "home.privacy.line1.span2");
        ɵɵadvance(2);
        ɵɵtextInterpolate1("", ctx.AppTitle, " ");
        ɵɵadvance(1);
        ɵɵproperty("translate", "home.privacy.line1.span3");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line2");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line3");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line4.span1");
        ɵɵadvance(2);
        ɵɵtextInterpolate1("", ctx.AppName, " ");
        ɵɵadvance(1);
        ɵɵproperty("translate", "home.privacy.line4.span2");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title2");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line5_1");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line5");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line6");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line7");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title3");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line8");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title4");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line9");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line10");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title5");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line11");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line12");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line13");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line14");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line15");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line16");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title6");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line17");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title7");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line18");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title9");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line19");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title10");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line20");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title11");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line21");
        ɵɵadvance(5);
        ɵɵproperty("translate", "home.privacy.title14");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line29");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title15");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line30");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title16");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line31");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title17");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line32");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line33");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title18");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line34");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line35");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line36");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line37");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.line38");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line39");
        ɵɵadvance(5);
        ɵɵproperty("translate", "home.privacy.title12");
        ɵɵadvance(3);
        ɵɵproperty("translate", "home.privacy.title13");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line22");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line23");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line24");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line25");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line26");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line27");
        ɵɵadvance(2);
        ɵɵproperty("translate", "home.privacy.line28");
    } }, directives: [HeaderComponent, TranslateDirective, FooterComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PrivacyComponent, [{
        type: Component,
        args: [{
                selector: 'lib-privacy',
                templateUrl: './privacy.component.html',
                styleUrls: ['./privacy.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }]; }, null); })();

const routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    }, {
        path: 'home',
        component: HomeComponent
    }, {
        path: 'ourStory',
        component: OurStoryComponent
    },
    {
        path: 'privacy',
        component: PrivacyComponent
    },
    {
        path: 'test',
        component: CdineshStaticPagesComponent
    }
];
class AppRoutingModule {
}
AppRoutingModule.ɵmod = ɵɵdefineNgModule({ type: AppRoutingModule });
AppRoutingModule.ɵinj = ɵɵdefineInjector({ factory: function AppRoutingModule_Factory(t) { return new (t || AppRoutingModule)(); }, imports: [[RouterModule.forChild(routes)],
        RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AppRoutingModule, { imports: [RouterModule], exports: [RouterModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AppRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();

class CdineshStaticPagesModule {
    static forRoot() {
        return {
            ngModule: CdineshStaticPagesModule,
            providers: [
                CdineshStaticPagesService
            ]
        };
    }
}
CdineshStaticPagesModule.ɵmod = ɵɵdefineNgModule({ type: CdineshStaticPagesModule });
CdineshStaticPagesModule.ɵinj = ɵɵdefineInjector({ factory: function CdineshStaticPagesModule_Factory(t) { return new (t || CdineshStaticPagesModule)(); }, providers: [], imports: [[
            AppRoutingModule,
            FormsModule, ReactiveFormsModule, CommonModule,
            TranslateModule.forChild()
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CdineshStaticPagesModule, { declarations: [CdineshStaticPagesComponent, HomeComponent, NavigationComponent, HeaderComponent, OurStoryComponent, PrivacyComponent, FooterComponent], imports: [AppRoutingModule,
        FormsModule, ReactiveFormsModule, CommonModule, TranslateModule], exports: [CdineshStaticPagesComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CdineshStaticPagesModule, [{
        type: NgModule,
        args: [{
                declarations: [CdineshStaticPagesComponent, HomeComponent, NavigationComponent, HeaderComponent, OurStoryComponent, PrivacyComponent, FooterComponent],
                imports: [
                    AppRoutingModule,
                    FormsModule, ReactiveFormsModule, CommonModule,
                    TranslateModule.forChild()
                ],
                providers: [],
                exports: [CdineshStaticPagesComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of cdinesh-static-pages
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CdineshStaticPagesComponent, CdineshStaticPagesModule, CdineshStaticPagesService, NavigationComponent };
//# sourceMappingURL=cdinesh-static-pages.js.map
